/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import MovieList from "../movieList/movieList";
import { connect } from "react-redux";
import LoadingIndicator from "../loadingIndicator/loadingIndicator";
import ErrorBoundry from "../errorBoundry/errorBoundry";
import { fetchPopularMovies } from "../../store/popular/actions";
import { getPopular } from "../../store/popular/selector";
import { loadMore } from "../../store/popular/actions";

const Popular = ({
  fetchPopular,
  loading,
  error,
  moviesPopular,
  page,
  loadMoreReq,
  slice
}) => {
  useEffect(() => {
    fetchPopular(page);
  }, []);

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorBoundry />;
  }

  if (slice) {
    return <MovieList movies={moviesPopular.slice(0, 5)} />;
  }

  const getMore = () => loadMoreReq(page + 1);

  return (
    <>
      <MovieList movies={moviesPopular} />
      <div className="load-more-wrap">
        <button className="load-more" type="button" onClick={getMore}>
          Load More
        </button>
      </div>
    </>
  );
};

const mapState = state => {
  return {
    moviesPopular: getPopular(state),
    loading: state.popular.loading,
    error: state.popular.loading,
    page: state.popular.page
  };
};

const mapDispatch = {
  fetchPopular: fetchPopularMovies,
  loadMoreReq: loadMore
};

export default connect(mapState, mapDispatch)(Popular);
